import PassportList from "./components/List"
import PassportTest from "./components/Test"

let module = "passports"

export default [
  { path: "passports", component: PassportList, meta: { module: module, permissions: ["passport-access"] } },
  { path: "passports/test/:id", component: PassportTest, props: true, meta: { module: module, permissions: ["passport-access"] } }
]
